var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"omapi-template-listing omapi-card__flex"},_vm._l((_vm.templates),function(template){return _c('templates-template-card',{key:'template-' + template.id,attrs:{"template":template}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }